module.exports = __webpack_public_path__ + "img/phone.f84d15f4.svg";